// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentPay_price-container__akJVn {
  width: 25vw;
  max-width: 417px;
  min-width: 230px;
}
.PaymentPay_price-container__akJVn p {
  margin: 0;
}
.PaymentPay_price-container__akJVn Button {
  margin-bottom: 16px;
  width: 100%;
}

.PaymentPay_sticky__sz5Sy {
  position: sticky;
  top: 5vw;
}

.PaymentPay_medium-subtitle__H0QmS {
  font-weight: bold;
  font-size: 20px;
  margin-bottom: 15px;
}

.PaymentPay_flex-space-between__KzYbX {
  display: flex;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/views/Payment/PaymentPay/PaymentPay.module.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAEA;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;AADJ;AAEI;EACI,SAAA;AAAR;AAEI;EACI,mBAAA;EACA,WAAA;AAAR;;AAIA;EACI,gBAAA;EACA,QAAA;AADJ;;AAIA;EACI,iBCdG;EDeH,eClBO;EDmBP,mBAAA;AADJ;;AAIA;EACI,aAAA;EACA,8BAAA;AADJ","sourcesContent":["@use \"styles/typography\";\n@use \"styles/colors\";\n.price-container {\n    width: 25vw;\n    max-width: 417px;\n    min-width: 230px;\n    p {\n        margin: 0;\n    }\n    Button {\n        margin-bottom: 16px;\n        width: 100%;\n    }\n}\n\n.sticky {\n    position: sticky;\n    top: 5vw;\n}\n\n.medium-subtitle {\n    font-weight: typography.$bold;\n    font-size: typography.$header-s;\n    margin-bottom: 15px;\n}\n\n.flex-space-between {\n    display: flex;\n    justify-content: space-between;\n}","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"price-container": `PaymentPay_price-container__akJVn`,
	"sticky": `PaymentPay_sticky__sz5Sy`,
	"medium-subtitle": `PaymentPay_medium-subtitle__H0QmS`,
	"flex-space-between": `PaymentPay_flex-space-between__KzYbX`
};
export default ___CSS_LOADER_EXPORT___;
